import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: '#17a2b8',
        },
        secondary: {
            main: '#158cba',
        },
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-input': { // More specific selector
                        padding: '10px 10px',
                        height: '20px', // Explicit height
                        lineHeight: '20px' // Match the height
                    },
                    '& input::placeholder': {
                        verticalAlign: 'top',
                        position: 'relative',
                        top: '50%',
                        transform: 'translateY(-50%)'
                    }
                }


            },
        },

        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        '& input': {
                            padding: '8px 12px',
                        }
                    },
                    '& .MuiInputLabel-root': { // This handles the floating label
                        transform: 'translate(14px, 8px) scale(1)',
                        '&.Mui-focused, &.MuiFormLabel-filled': {
                            transform: 'translate(14px, -9px) scale(0.75)'
                        }
                    },
                    '& fieldset': {
                        borderColor: 'orange', // Set your desired color here (e.g., orange)
                    },
                    '&.Mui-focused': {
                        borderColor: '#17a2b8', // Color on focus
                    },
                    '&:hover': {
                        borderColor: '#17a2b8', // Hover effect
                    },
                    '&.Mui-error': {
                        '& fieldset': {
                            borderColor: '#d32f2f', // Red border when there's an error
                        },
                    },
                    '&.Mui-success': {
                        '& fieldset': {
                            borderColor: '#28a745', // Green border when valid
                        },
                    },
                    '&.MuiCustom-success .MuiInputBase-input': {
                        color: '#027843',
                    },
                    '&.MuiCustom-success .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#027843',  // Green label when valid
                        }
                    },
                    '&.MuiCustom-success .MuiInputLabel-root': {
                        color: '#027843',  // input label on focused
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    '&:disabled': {
                        background: '#6c757d',
                        color: 'white'
                    }
                }
            },
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        border: `2px solid #17a2b8`,
                        '&:hover': {
                            background: '#17a2b8',
                            color: "white",
                            border: "2px solid  #17a2b8"
                        }
                    },
                },
                {
                    props: { variant: 'outlined', color: 'error' },
                    style: {
                        border: `2px solid #d32f2f`,
                        '&:hover': {
                            background: '#d32f2f',
                            color: "white"
                        }
                    },
                },
            ],
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    color: 'orange', // Default label color when untouched
                    '&.Mui-focused': {
                        color: '#17a2b8', // Label color on focus
                    },
                    '&:hover': {
                        color: '#17a2b8', // Label color on hover
                    },
                    '&.Mui-error': {
                        color: '#d32f2f', // Label color when there's an error
                    },
                    '&.Mui-success': {
                        color: '#28a745', // Label color when valid (success)
                    },
                    '&.MuiCustom-success': {
                        color: '#027843',  // Green label when valid
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'orange', // Default label color when untouched
                    '&.Mui-focused': {
                        color: '#17a2b8', // Label color on focus
                    },
                    '&:hover': {
                        color: '#17a2b8', // Label color on hover
                    },
                    '&.Mui-error': {
                        color: '#d32f2f', // Label color when there's an error
                    },
                    '&.Mui-success': {
                        color: '#28a745', // Label color when valid (success)
                    },
                    '&.MuiCustom-success': {
                        color: '#027843',  // Green label when valid
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'orange', // Default border color when untouched
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#17a2b8', // Border color on focus
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#d32f2f', // Border color on error
                    },
                    '&.Mui-success .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#28a745', // Border color when valid (success)
                    },
                    '&.MuiCustom-success .MuiInputBase-input': {
                        color: '#027843',
                        '& fieldset': {
                            borderColor: '#027843',  // Green label when valid
                        }
                    },
                    '&.MuiCustom-success .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#027843',
                    },
                },
            },
        },
    },
});

export default theme;
